module.exports = __webpack_public_path__ + "media/images/signatures/sara_white-10d932560780857c59a9fd13a2eb7821.png";